import styled from "styled-components";

const Container = styled.div`
  height: max(130px, fit-content);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px;
  border-radius: 10px;
  position: relative;
  box-shadow:
    0px 5px 15px rgba(0, 0, 0, 0.05),
    0px 1px 4px rgba(0, 0, 0, 0.25);
`;

const Icon = styled.div`
  > :first-child {
    width: 60px;
    height: 60px;
  } 
`;

const Description = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
  align-self: start;
  padding-right: 30px;
`;

const Checkbox = styled.div`
  align-self: flex-start;
  position: absolute;
  right: 16px;
  top: 16px;
  
  > .MuiCheckbox-root {
    padding: 0 !important;
  }
  
  > .MuiSvgIcon-root {
    fill: ${(props) => props.theme.colors.primary} !important;
  }
`;

export { Container, Icon, Description, Checkbox };